"use strict";

import _Object$assign from "babel-runtime/core-js/object/assign";
import _classCallCheck from "babel-runtime/helpers/classCallCheck";

var Item = function Item(data) {
    _classCallCheck(this, Item);

    _Object$assign(this, data);
};

export default Item;
;


//////////////////
// WEBPACK FOOTER
// ./submodules/dialogloop-sdk-js/dist/Items/Item.js
// module id = 35
// module chunks = 0